import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

let visibleGroup = null;
const sessionId = typeof crypto !== 'undefined' && crypto.randomUUID
  ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

function pageIsVisible() {
  return document.visibilityState === 'visible' && document.hasFocus();
}

export function isViewingChat(groupId) {
  return visibleGroup === groupId && pageIsVisible();
}

// Each tab has its own presence document. Another tab cannot mark this one closed.
export function trackChatPresence(groupId, userId) {
  const ref = doc(db, 'groups', groupId, 'chatPresence', userId, 'sessions', sessionId);
  let stopped = false;
  let lastActive = null;
  const write = (active) => setDoc(ref, { active, updatedAt: serverTimestamp() }).catch((error) => {
    // Foreground push suppression still works if presence cannot be synchronized.
    console.warn('Unable to synchronize chat presence:', error.code);
  });
  const update = () => {
    if (stopped) return;
    const active = pageIsVisible();
    visibleGroup = active ? groupId : null;
    if (active || lastActive !== active) write(active);
    lastActive = active;
  };
  const hide = () => {
    visibleGroup = null;
    lastActive = false;
    write(false);
  };
  document.addEventListener('visibilitychange', update);
  window.addEventListener('focus', update);
  window.addEventListener('blur', hide);
  window.addEventListener('pagehide', hide);
  window.addEventListener('pageshow', update);
  // The server expires a missed heartbeat after 45 seconds (app killed/offline).
  const heartbeat = window.setInterval(update, 15000);
  update();
  return () => {
    stopped = true;
    window.clearInterval(heartbeat);
    document.removeEventListener('visibilitychange', update);
    window.removeEventListener('focus', update);
    window.removeEventListener('blur', hide);
    window.removeEventListener('pagehide', hide);
    window.removeEventListener('pageshow', update);
    hide();
  };
}
